module.exports = __webpack_public_path__ + "img/1589954261.a95dc6bb.jpg";